export default __webpack_public_path__ + "static/media/satoshiat.5fadc04d.png";